var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.postArray.length > 0)?_c('div',{attrs:{"id":"stream-container"}},[_c('Stream',{attrs:{"postArray":_vm.postArray}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }